import type { Deal } from '@/types'

export const REUNIAO_REQUIRED_MESSAGE =
  'Informe a data e hora da reunião na seção "Agendar Reunião" antes de avançar para Reunião Agendada.'

export const REUNIAO_REQUIRED_FIELD = 'dataReuniao'

/** Deal qualificado com reunião agendada (registro ou data no deal). */
export function hasScheduledMeeting(deal: Pick<Deal, 'dataReuniao' | 'reunioes'>): boolean {
  const reuniaoComData = deal.reunioes?.some((r) => {
    if (!r.data) return false
    const parsed = new Date(r.data)
    return !Number.isNaN(parsed.getTime())
  })
  if (reuniaoComData) return true

  if (!deal.dataReuniao?.trim()) return false
  const parsed = new Date(deal.dataReuniao)
  return !Number.isNaN(parsed.getTime())
}
